import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const eur = (n) => new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(n || 0);

export default function ServiceProductCosts() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/analytics/service-product-costs").then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  if (!d) return null;
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5" data-testid="service-product-costs">
      <h3 className="font-heading text-base font-semibold text-slate-900">Coût produits moyen réel par prestation</h3>
      <p className="text-[11px] text-slate-500 mb-3">Calculé uniquement à partir des consommations réelles saisies dans « Produits utilisés ». Information interne : aucun tarif, devis ou facture n'est modifié.</p>
      {d.rows.length === 0 ? <p className="text-sm text-slate-500" data-testid="spc-empty">Pas encore de données : enregistrez vos produits utilisés dans les dossiers atelier pour obtenir ce calcul.</p> : (
        <div className="divide-y divide-slate-100">
          {d.rows.map((r) => (
            <div key={r.service} className="py-2 flex flex-wrap items-baseline justify-between gap-2" data-testid="spc-row">
              <div className="min-w-0"><div className="text-sm font-medium text-slate-900 break-words">{r.service}</div>
                <div className="text-[11px] text-slate-500">{r.count} prestation(s) avec données réelles{r.count > 1 ? ` · min ${eur(r.min)} · max ${eur(r.max)}` : ""}{r.combined ? " · prestations combinées" : ""}</div></div>
              <div className="text-right"><div className="text-sm font-bold" data-testid="spc-avg">{eur(r.avg)}</div>
                {!r.enough_data && <div className="text-[10px] text-amber-700">Peu de données (moins de {d.min_samples})</div>}</div>
            </div>
          ))}
        </div>
      )}
      {d.incomplete_sheets > 0 && <p className="text-[11px] text-slate-400 mt-2" data-testid="spc-incomplete">{d.incomplete_sheets} dossier(s) ignoré(s) : prix d'achat ou contenance manquant sur un produit.</p>}
    </div>
  );
}
